export default __webpack_public_path__ + "static/media/cork-inside.3da13b7b.svg";